import React from 'react';
import {Body, Button, Icon, Label} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import LEGACY_COLORS from '@/config/legacyColors';
import styles from './SelectionBanner.module.scss';

export type SelectionBannerProps = {
  isAllFilterMatchingSelected: boolean;
  currentPageCount: number;
  totalResultsCount: number;
  onSelectAll: () => void;
  onClearSelection: () => void;
};

function SelectionBanner({
  isAllFilterMatchingSelected,
  currentPageCount,
  totalResultsCount,
  onSelectAll,
  onClearSelection,
}: SelectionBannerProps) {
  const showSelectAllPrompt =
    !isAllFilterMatchingSelected && totalResultsCount > currentPageCount;
  const selectAllLabel = translate('Select all {count} creators?', {
    count: totalResultsCount.toLocaleString(),
  });

  return (
    <div className={styles.banner}>
      <Icon
        appearance="neutral"
        size="medium"
        name="Actions-Info-Line"
        color={LEGACY_COLORS.PURPLE_MEDIUM}
      />
      <Body
        size="md"
        className={styles.bannerText}
        color={LEGACY_COLORS.PURPLE_DARK}
      >
        {isAllFilterMatchingSelected
          ? translate('All creators are selected.', {
              count: totalResultsCount.toLocaleString(),
            })
          : translate('All creators on this page are selected.', {
              count: currentPageCount,
            })}
        {showSelectAllPrompt && (
          <Label
            component="span"
            size="md"
            underline
            className={styles.selectAllTrigger}
            onClick={onSelectAll}
            color={LEGACY_COLORS.PURPLE_DARK}
          >
            {selectAllLabel}
          </Label>
        )}
      </Body>
      <Button
        className={styles.clearAllButton}
        variant="text"
        size="small"
        onClick={onClearSelection}
      >
        {translate('Clear Selection')}
      </Button>
    </div>
  );
}

export default SelectionBanner;
